import React, { ComponentProps, PropsWithChildren, forwardRef } from 'react'
import _FloatingDropdown from '../_FloatingDropdown'
import DropdownListSheet from './DropdownListSheet'

type InheritedSheetProps = Pick<ComponentProps<typeof DropdownListSheet>, 'size' | 'width'>
type InheritedFloatingDropdownProps = Pick<ComponentProps<typeof _FloatingDropdown>, 'placement' | 'crossAxisShift' | 'autoHeight' | 'anchorRef' | 'anchorOffset' | 'boundaryRef' | 'triggerRef' | 'open' | 'portaled' | 'onClose' | 'id' | 'data-testid'>

interface Props extends PropsWithChildren, InheritedSheetProps, InheritedFloatingDropdownProps {
  enableFlip?: boolean
}

const DropdownListBase = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const {
    children,
    size,
    width,
    placement,
    enableFlip,
    crossAxisShift,
    autoHeight,
    open,
    anchorRef,
    anchorOffset,
    boundaryRef,
    triggerRef,
    'data-testid': dataTestId,
    id,
    onClose,
    portaled,
  } = props

  return <_FloatingDropdown
    ref={ref}
    width={size === 'fill-anchor' ? 'match-anchor' : 'auto'}
    placement={placement}
    anchorRef={anchorRef}
    anchorOffset={anchorOffset}
    boundaryRef={boundaryRef}
    triggerRef={triggerRef}
    open={open}
    disableFlip={!enableFlip}
    crossAxisShift={crossAxisShift}
    autoHeight={autoHeight}
    data-testid={dataTestId}
    id={id}
    onClose={onClose}
    portaled={portaled}
  >
    <DropdownListSheet size={size} width={width} autoHeight={autoHeight}>
      {children}
    </DropdownListSheet>
  </_FloatingDropdown>
})

DropdownListBase.displayName = 'DropdownListBase'

export default DropdownListBase
